import React, { useState } from 'react';
import { EaseModal } from '../../../libs/EaseModal';
import { Text1 } from '../../../styles';
import { Form, Button, Input } from 'antd';
import { Merchant } from '../../../models';
import { alertify, handleApiExceptions } from '../../../app_methods';

let LoadEditAccountModalForm = (props) => {
    const { form, merchant, account } = props;
    const { getFieldDecorator } = form;
    const [isSubmitting, setIsSubmitting] = useState(false);

    const onSubmit = (e) => {
        e.preventDefault();
        form.validateFields((err) => {
            if (err) return;
            editLabel(form.getFieldsValue());
        });
    };

    const editLabel = async (values) => {
        setIsSubmitting(true);
        const response = await Merchant.update_label(values);
        if (!response.success) {
            setIsSubmitting(false);
            handleApiExceptions(response);
            return;
        }
        alertify("Success", `Account label updated successfully.`, "success");
        setIsSubmitting(false);
        props.fetchAllotedAccounts();
        props.editAccountModal();
        props.fetchMerchantInfo()
    }

    const renderTitle = () => {
        return (
            <Text1 className="d-block mb-4" strong>Edit Wallet Label</Text1>
        );
    };

    return (
        <EaseModal
            width={400}
            title={false}
            visible={props.visible}
            onCancel={props.editAccountModal}
            centered
            hideFooter
            destroyOnClose
        >
            {renderTitle()}
            <Form onSubmit={onSubmit}>
                {getFieldDecorator("account_id", {
                    initialValue: account?.id
                })(<Input autoComplete='off' hidden />)}
                <Form.Item label={'Label'}>
                    {getFieldDecorator("label", {
                        rules: [{ required: true, message: "Label is required." }],
                        initialValue: account?.label_name
                    })(<Input placeholder={`Current Label: ${account?.label_name}`} />)}
                </Form.Item>
                <div className="w-100 d-flex justify-content-end mt-4">
                    <Button type="primary" htmlType="submit" loading={isSubmitting}>Submit</Button>
                </div>
            </Form>
        </EaseModal>
    );
};

const LoadEditAccountModal = Form.create()(LoadEditAccountModalForm);

export { LoadEditAccountModal };
